export default __webpack_public_path__ + "static/Recoleta-SemiBold-198bf35ae9c5c44e4d997fac31c293a1.woff2";